export default "__VITE_ASSET__CJqiSAn8__"